<div class="slider-header">
    {{model.name}}
    <div class="slider-wrapper">
        <input class="lower" type="number" min="{{model.options.floor}}" [(ngModel)]="model.minValue">
        <div class="slider-inner-wrapper">
            <ngx-slider [(value)]="model.minValue" [(highValue)]="model.maxValue" [options]="model.options"></ngx-slider>
        </div>
        <input class="upper" type="number" max="{{model.options.ceil}}" [(ngModel)]="model.maxValue">
    </div>
</div>